import React from 'react'

const Copywrite = ({ title = '© 2024 Byggframtid' }) => (
  <div className="footer__copywrite">
    <span>{title}</span>
  </div>
)

export default Copywrite
